<template>
    <b-modal ref="modal" size="lg" :hide-footer="false">
        <template slot="modal-header" >
            <div>
              Track Comparison
            </div>
        </template>
        <template >
            <div class="upload">
                <div class="body">
                  <template>
                    <span style="padding-bottom: 7px">Use this feature to compare your tracks with our system and identify missing ones. You can also move matching tracks to a playlist.</span><br><br><br>
                    <span>Follow these steps to use the feature:</span><br><br>
                    <span>1. Download the CSV file template by clicking the 'Download Template' button.</span><br>
                    <span>2. Fill in the necessary information for each track in the CSV file.</span><br>
                    <span>3. Upload the filled CSV file using the 'Upload File' button.</span><br>
                    <span>4. View the results and take action on missing tracks.</span><br><br>
                    <Button :empty="empty" @click="download"  style="margin-top: 15px ; margin-left: 250px " download>
                      <template>{{  'Download template' }}</template>
                    </Button>
                  </template>
                </div>
            </div>
        </template>
        <template slot="modal-footer">
            <Button :empty="empty" style="background: #ffffff; color: #EA8F34" class="close-popup" @click.prevent="$refs.modal.hide()">{{ Translations.buttons.cancel }} </Button>
            <button :empty="empty" class="primary"  :disabled="null" @click.prevent="confirm">Upload File</button>
        </template>

    </b-modal>

</template>

<script>
    import Bootstrap from "bootstrap-vue";
    import Constants from "@/store/constants";
    import Translations from "@/store/translations";
    import {mapState} from 'vuex'
    import store from "@/store";
    import Button from "@/components/common/Button.vue";
    import Axios from "axios";

    export default {
        name: "UploadFile",
        store,
        components: {Button},
        props: {
          empty: { type: Boolean, required: true, default: false },
        },
        computed: {
            ...mapState(['currentStation' ]),
            Translations: () => Translations,
            Constants: () => Constants,

        },
        data() {

            return {
            };
        },
      mounted() {
        // this.loadStations();
      },
        watch: {
            type: { }
        },

        methods: {
          resetModalState(toggler) {

          },
          download () {
            const url = '../../../Template.csv';
            // window.location.href = url;
            Axios.get(url, { responseType: 'blob' })
                .then(response => {
                  const blob = new Blob([response.data], { type: 'text/csv' })
                  const link = document.createElement('a')
                  link.href = URL.createObjectURL(blob)
                  link.download = 'Template'
                  link.click()
                  URL.revokeObjectURL(link.href)
                }).catch(console.error)
          },
          show() {
            this.clean();
          //  this.loadStations();
            this.$refs.modal.show();
          },
          hide() {
            this.$refs.modal.hide();
          },
          confirm() {
            this.$emit("confirmed");
            this.hide();
          },

          clean(){
          },
        },

    };
</script>

<style lang="scss" scoped>
    .upload {
        width: 480px;
    }

    header {
        font-size: 26px;
        color: #292c33;
        text-align: center;

        padding: 35px;
    }

    .body {
        padding: 0 35px 35px 35px;

        h3 {
            color: #696b70;
            font-size: 13px;
        }
    }

    .count {
        color: #000;
        font-weight: 600;
    }

    footer {
        border-top: 1px solid #d2d2d2;
        height: 80px;
        padding: 35px;

        a {
            color: #d2d2d2;
            text-transform: uppercase;
            font-size: 13px;
        }

        button {
            text-transform: uppercase;
        }
    }
    .upload-box{
        li{
            height: auto;
            input{
                &[type=radio]{
                    height: 24px;
                }
            }
            label{
                margin: 0;
            }
        }
    }
    .search-container {
      overflow: hidden;
      height: 100%;
      height:400px;
      display:flex;
      flex-direction:column;
      flex-grow: 1;
      justify-content: stretch;
      align-self: flex-start;
      ul{
        height: 100%;
        overflow: auto;
        input{
          font-size: 13px;
          font-weight: 600;
          letter-spacing: 0.7px;
          line-height: 1;
        }
        li {
          span{
            font-weight:600;
            font-size:12px
          }
          span.badge {
            font-weight:400;
            font-size:10px
          }
        }
      }
    }

    .box-source-wrapper {
      position: relative;
      padding-left: 25px;

      i {
        position: absolute;
        left: 0;
        top: 5px;
      }
    }

    .search-container .search-content {
      display: flex;
      flex-grow: 1;
      flex-direction: row;
      flex-shrink: 0;
      height: 100%;
    }

    .source-column li.header {
      position: sticky;
      top: 0;
      background:#fff;
      z-index:100;
      padding: 10px;
      border-bottom: 1px solid #dee2e6;
      height:41px;
      display:flex;
      align-items: center;
    }

    #station-source.source-column {
      width: 70%;
      height: 100%;
      overflow: auto;
    }

    #box-source.source-column {
      width: 50%;
      flex-shrink: 0;
      border-right: 1px solid #dee2e6;
    }

    .search-container header {
      display: flex;
      justify-content: space-between;
      align-content: center;
      align-items: center;
      padding: 10px 15px;
      border-bottom: var(--COLOR_BORDERS) 1px solid;
    }

    .search-container header h4 {
      margin: 0;
    }

    .source-column li {
      height: auto;
      padding: 7px 10px;
      align-items: baseline;
    }

    .source-column li i {
      margin-right: 15px;
    }

    .source-column li i:hover {
      margin-right: 15px;
      color: var(--COLOR_BRAND);
    }



    .source-column li .station-label {
      font-size: 12px;
      font-weight: 600;
    }

    .source-column li i.fa-check {
      opacity: 0.1;
      transition: color 0.2s ease-in-out;
    }

    .source-column li.active i.fa-check {
      opacity: 1;
      color: var(--COLOR_BRAND);
    }
    .source-column{
      li {
        .input{
          width: 100%;
        }
      }
    }

</style>
